import { Page, PageHeader, Box } from '@chatsdet/ui';
import { House } from '@phosphor-icons/react';
import { useBreadcrumbs } from '../../contexts/BreadcrumbsContext';
import { useAuth } from '../../contexts/AuthContext';
import { AppScoreCard } from './components/AppScoreCard';
import { DigestsCard } from './components/DigestsCard';
import { ProductCoverageCard } from './components/ProductCoverageCard';
import { TestExecutionChart } from './components/TestExecutionChart';
import { FlowsNeedingAttention } from './components/FlowsNeedingAttention';
import { ScheduledRuns } from './components/ScheduledRuns';
import { RecentActivity } from './components/RecentActivity';

export function HomeDashboard() {
  const { user } = useAuth();
  const hasQaPageTester = !!user?.features?.qaRuns;

  useBreadcrumbs([
    {
      label: 'Home',
    },
  ]);

  return (
    <Page>
      <PageHeader
        icon={<House size={24} />}
        title="Dashboard"
        description="High-level view of your organization activity."
      />
      <DigestsCard className="mt-6" />
      {user?.orgId && <TestExecutionChart className="mt-6" orgId={user.orgId} />}
      {hasQaPageTester && <AppScoreCard className="mt-6" />}
      <ProductCoverageCard className="mt-6" />
      {/* Regression-first widgets: what's broken/flaky, what's scheduled (stacked
          in the 2/3 column), with a compact activity feed in its own 1/3 column. */}
      <Box className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="flex flex-col gap-6 lg:col-span-2">
          <FlowsNeedingAttention />
          <ScheduledRuns />
        </div>
        <RecentActivity className="lg:col-span-1" />
      </Box>
    </Page>
  );
}
